import React, { useEffect, useState, useMemo } from "react";
import {
  getAllItemsFromExternalData,
  getImplementation,
  getComments,
  getNewItem,
  getMedia,
  getCampaign
} from "../app/API/commentAPI";
import {
  setImplementation,
  setMapData,
  mapViewSelectors,
  setCampaign
} from "../app/slices/mapViewSlice";
import {
  selectors,
  setSkip,
  resetSkipAndTop,
  setItem,
  setSortByStarred,
  setSortAscending,
  setShowContributionsWithPhotos
} from "../app/slices/itemSlice";
import {
  selectors as mediaSelectors,
  setMedia,
  setShowGallery,
} from "../app/slices/mediaSlice";
import { connect } from "react-redux";
import { MainMap } from "./maps/MainMap";
import CommentList from "./CommentList/CommentList";
import PendingCommentList from "./PendingCommentList/PendingCommentList";
import Modal from "./Modal/Modal";
import AddContributionModal from "./Modals/AddContributionModal";
import AddContributionSection from "./AddContributionSection/AddContributionSection";
import { IsUserLoggedIn } from "../helpers/authHelper";
import SortHeader from "./SortHeader/SortHeader";
import FsLightbox from "./FsLightbox/FsLightbox";
import LoadingSpinner from "./LoadingSpinner";
import LoadMoreButton from "./LoadMoreButton";
import { getProfileData } from "../app/API/profileAPI";
import { getUserProperties } from "../helpers/authHelper";
import { addImagesToPopup } from "../helpers/map/popupHelper";

function Mapview(props) {
  const {
    implementationId,
    mapData,
    campaign,
    campaignId,
    setCampaign,
    item,
    setImplementation,
    setMapData,
    setItem,
    skip,
    top,
    sortAscending,
    sortByStarred,
    sortPinned,
    showContributionsWithPhotos, 
    showGallery,
    setMedia,
    setSkip
  } = props;

  const user = getUserProperties()

  const [externalId, setExternalId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [mergePins, setMergePins] = useState(false);
  const [loadingComments, setLoadingComments] = useState(false);
  const [pinSelected, setPinSelected] = useState(false);
  const { REACT_APP_SIGNINURL } = process.env;
  const [validAddressForNewPin, setValidAddressForNewPin] = useState(true);
  const [showComments, setShowComments] = useState(true); 
  const [profile, setProfile] = useState({});

  const handleIdChange = (newId, pinSelected = true) => {
    props.resetSkipAndTop();    
    setExternalId(newId);
    setPinSelected(pinSelected);
    setShowComments(pinSelected);   
  };

  const updatePopupContent = (containerDiv, externalId) => {
    // Find the element
    let elem = mapData.mapData.find(x => x.externalId === externalId) ;
    // Determine whether we want to show image in the popup
    let showImageInPopup = elem && elem.name && elem.itemImageUrl && elem.itemImageUrl != "";
    if(showImageInPopup){ 
      let textDiv = containerDiv.querySelector('.ugc__map-popup-content')
      let contentDiv = containerDiv.querySelector('.he-grid-row');
      addImagesToPopup(elem.itemImageUrl, elem.name, textDiv, contentDiv, true);
    }
  }

  const mapDetailsLoaded = useMemo(() => {
    if((campaignId && campaignId.toUpperCase() === mapData.campaign.id.toUpperCase()) || mapData.mapData.length) { 
      return true; 
    }
    return false; 
  }, [campaign, mapData.campaign, mapData.mapData]);

  const title = useMemo(() => {
    if(campaignId && campaignId.toUpperCase() === mapData.campaign.id.toUpperCase()) {
      return mapData.campaign.name; 
    }

    return mapData.implementation?.title ?? mapData.implementation?.name;

  }, [campaign, mapData.campaign, mapData.implementation.title, mapData.implementation.name]);

  useEffect(() => {
    (async function () {
      try {
        if (mapData.implementation.id !== implementationId) {
          let implementationResponse = await getImplementation(implementationId);
          setImplementation(implementationResponse);
        }
      } catch {
        console.log("failed to load implementation");
      }
    })();
  }, [implementationId]);

  useEffect(() => {
    (async function() {
      if (mapData.implementation.id !== "") {
        try {
          // Get the campaign data
          if(campaignId !== "" && campaignId !== mapData.campaign.id) {
            let campaignResponse = await getCampaign(mapData.implementation.id, campaignId);

            // Set the campaign
            if(campaignResponse.isValid !== false) {
              setCampaign(campaignResponse);
            } 
          }
        } catch {
          console.log("Failed to load campaign");
        }
  
        try {
          if (
            campaignId === ""
          ) {
            let itemsResponse = await getAllItemsFromExternalData(implementationId);
            setMapData(itemsResponse);
          }

        } catch {
          console.log("Failed to load map data");
        }
    }
    })();
  }, [mapData.implementation.id, campaignId]);

  useEffect(() => {
    (async function () {
      setLoadingComments(true);  
      //The external id has changed, load the first batch of comments.
      if (
        externalId !== "" &&
        externalId !== "-1" &&
        externalId !== item.externalId
      ) {     
        let response = await getComments(
          implementationId,
          externalId,
          0,
          10,
          false,
          false,
          true,
          false
        );

        if (response.id === undefined && externalId !== "-1") { 
          response = await getNewItem(implementationId, externalId);
        }
        if (response.externalId && response.id) {
          response.implementation = props.mapData.implementation; 
          setItem(response);
          setValidAddressForNewPin(true);
        }
      }
      
      setLoadingComments(false);
    })();
  }, [externalId, implementationId, item.externalId, setItem]);

  useEffect(() => {
    (async function () {
      if (
        props.reloadComments ||
        (externalId !== "" &&         
          externalId === item.externalId &&
          (!props.item.comments || skip + top > props.item.comments.length) &&
          props.moreComments)
      ) {
        let response = await getComments(
          implementationId,
          externalId,
          skip,
          top,
          sortAscending,
          sortByStarred,
          sortPinned,
          showContributionsWithPhotos
        );

        if (response.externalId) {
          setItem(response);
        }
      }
    })();
  }, [props.item.comments, props.moreComments, props.reloadComments, implementationId, item.externalId, setItem, skip, sortAscending, sortByStarred, top]);

  useEffect(() => {
    (async function () {
      try {
        if (externalId) {
          const mediaResponse = await getMedia(externalId);
          if (!mediaResponse.errors) {
            setMedia(mediaResponse);
          }
        }
      } catch {
        console.log("failed to load media for gallery");
      }
    })();
  }, [externalId, setMedia]);

  useEffect(() => {
    (async function () {
      document.documentElement.style.overflow = showModal ? 'hidden' : '';
    })();
  }, [showModal]);

  /**
   * Get the profile data
   * Used for determining whether the logged is an organisation user or not
   */
    useEffect(() => {
      (async () => {
        const response = await getProfileData(user?.userId);
        // Check if the response is valid
        if (response.isValid || response.isValid === undefined) {
          setProfile(response);
        }
      })();
    }, [user?.userId]);

  const mapProperties = useMemo(() => {
    const centre = {
      x: mapData.implementation.centrePointEasting,
      y: mapData.implementation.centrePointNorthing,
    };
    const bounds = {
      ule: mapData.implementation.topLeftEastingBounds,
      uln: mapData.implementation.topLeftNorthingBounds,
      lre: mapData.implementation.bottomRightEastingBounds,
      lrn: mapData.implementation.bottomRightNorthingBounds,
    };

    return { centre, bounds };
  }, [mapData]);

  if (!mapData.implementation.useMapView) {
    return (
      <>
        <div>
          <h2>This implementation does not support map view.</h2>
        </div>
      </>
    );
  }

  const Cta = ({ isUserLoggedIn }) => {
    const notSignedInContent = 'Add your comments to the map';
    const isSignedInContent = `Explore the map below or <a rel="nofollow" href=${REACT_APP_SIGNINURL}/?u=&referrer=${window.location}> sign in </a> to make a comment`;
    return (
      <div className={`ugc__map-contribute-cta ${isUserLoggedIn ? "ugc__map-contribute-cta--signed-in" : "cta--signed-out"}`}>
        <h2 className="ugc-map-contribute-cta__title">
          {title}
        </h2>
        <p className="ugc-map-contribute-cta__content"
           dangerouslySetInnerHTML={{ __html: isUserLoggedIn ? notSignedInContent : isSignedInContent }}/>
        <small className="ugc-map-contribute-cta__terms">
          By using this map you are agreeing to the <a className="ugc-map-contribute-cta__link" href="/terms/">terms and conditions</a>
        </small>
      </div>
    )
  };

  return (
    <>
      {showModal && (
        <Modal
          closeRootModal={() => setShowModal(!showModal)}
          confirmClose={true}
          dismissError={props.dismissError}
        >
          <AddContributionModal
            closeRootModal={() => setShowModal(!showModal)}
            confirmClose={true}
            item={props.item}
            allowMapOnModal={mapData.implementation.allowMapOnModal}
            setMergePins={setMergePins}
            allowUsersToSetAlias={mapData.implementation.allowUsersToSetAlias}
          />
        </Modal>
      )}

      <Cta isUserLoggedIn={IsUserLoggedIn()}/>

      {mapDetailsLoaded? (
        <MainMap
          mapdata={mapData.mapData}
          campaign={mapData.campaign}
          centre={mapProperties.centre}
          zoom={mapData.implementation.defaultZoom}
          minimumZoom={mapData.implementation.minZoom}
          bounds={mapProperties.bounds}
          allowUsersToSetPins={mapData.implementation.allowUsersToSetPins}
          handleIdChange={handleIdChange}
          updatePopupContent={updatePopupContent}
          setShowModal={setShowModal}
          setItem={props.setItem}
          implementation={mapData.implementation}
          isUserLoggedIn={IsUserLoggedIn()}
          mergePins={mergePins}
          setMergePins={setMergePins}
          setValidAddressForNewPin={setValidAddressForNewPin}
          currentItemId={props.item.externalId}
          setReloadComments={props.setReloadComments}
        />
      ) : (
        <div/>
      )}
      <div id="commentContainer">
        {!mapData.implementation.active ? (
          <div>
            <p>
              This discussion is now closed, all comments are still available to
              view.
            </p>
          </div>
        ) : externalId === "" || !loadingComments ? (
          <>
            {
              pinSelected &&
              <>
              <h3 id="showingCommentsMessage">
                Showing comments for {props.item.name}
              </h3>
              <AddContributionSection
                setShowModal={setShowModal}
                showModal={showModal}
                isUserLoggedIn={IsUserLoggedIn()}
                totalCommentsLength={props.totalComments}
                appType={'mapview'}
                pinSelected={pinSelected}
                validAddressForNewPin={validAddressForNewPin}
                isOrganisation={profile.isOrganisation}
                organisationName={profile.organisationName}
              />
            </>
        }
        </>
        ) : (
          <LoadingSpinner/>
        )}
        {props.item.pendingComments && showComments ? (
          <PendingCommentList
            comments={props.item.pendingComments}
            externalId={props.item.externalId}
            item={props.item}
            top={props.top}
            skip={props.skip}
            setSkip={props.setSkip}
          />
        ) : null}
        {pinSelected &&
        <SortHeader
          sortAscending={sortAscending}
          sortByStarred={sortByStarred}
          setAscending={props.setAscending}
          showContributionsWithPhotos={showContributionsWithPhotos}
          setShowContributionsWithPhotos={props.setShowContributionsWithPhotos}
          setSortByStarred={props.setSortByStarred}
        />
        }
        {externalId !== "" && props.item.comments && showComments ? (
          <div id="commentList">
            <CommentList
              item={props.item}
              comments={props.item.comments}
              externalId={props.item.externalId}
              top={top}
              skip={skip}
              maxChars={mapData.implementation.maxChars}
            />
          </div>
        ) : (
          <div/>
        )}

        <div className="ugc-comments-list__footer">
          <div className="ugc-comments-list__footer-content">
            {pinSelected ? (
              props.item.comments && props.moreComments ? (
                <LoadMoreButton
                  top={top}
                  skip={skip}
                  setSkip={setSkip}/>
              ) : (
                  <div className="ugc-comments-list__no-comments">
                  There aren't any {props.item.comments.length > 0 && "more"} comments
                </div>
              )
            ) : null}
          </div>
          {pinSelected && !IsUserLoggedIn() && (
            <div className="ugc-comments-list__sign-in-prompt">
              <a rel="nofollow" href={`${REACT_APP_SIGNINURL}/?u=&referrer=${window.location}`}> Sign in to comment </a>
            </div>
          )}
        </div>
      </div>
      {props.media.length > 0 ? (
        <FsLightbox
          showGallery={showGallery}
          externalId={externalId}
          media={props.media}
        />
      ) : (
        <div/>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    implementation: mapViewSelectors.implementation(state),
    mapData: mapViewSelectors.mapData(state),
    campaign: mapViewSelectors.campaign(state),
    skip: selectors.skip(state),
    top: selectors.top(state),
    item: selectors.item(state),
    sortAscending: selectors.sortAscending(state),
    sortByStarred: selectors.sortByStarred(state),
    showContributionsWithPhotos: selectors.showContributionsWithPhotos(state),
    sortPinned: selectors.sortPinned(state),
    maxChars: selectors.maxChars(state),
    moreComments: selectors.moreComments(state),
    reloadComments: selectors.reloadComments(state),
    totalComments: selectors.totalComments(state),
    media: mediaSelectors.media(state),
    showGallery: mediaSelectors.showGallery(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setImplementation: (implementation) => dispatch(setImplementation(implementation)),
    setMapData: (mapData) => dispatch(setMapData(mapData)),
    setCampaign: (campaign) => dispatch(setCampaign(campaign)),
    setSkip: (skip) => dispatch(setSkip(skip)),
    setItem: (item) => dispatch(setItem(item)),
    resetSkipAndTop: () => dispatch(resetSkipAndTop()),
    setAscending: (value) => dispatch(setSortAscending(value)),
    setSortByStarred: (value) => dispatch(setSortByStarred(value)),
    setShowContributionsWithPhotos: (value) => dispatch(setShowContributionsWithPhotos(value)),
    setMedia: (media) => dispatch(setMedia(media)),
    setShowGallery: (value) => dispatch(setShowGallery(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Mapview);
